import { API_PREFIX } from '@/config/api'
import type {
    ProductionLineCreateModel,
    ProductionLineModel
} from '@/types/models/ProductionLineModel'
import { api } from '@rfc/rfc-components-library/helpers'
import type { PaginationType } from '@rfc/rfc-components-library/types'
import { buildQueryUrl } from '@rfc/rfc-components-library/utils'
import type { AxiosResponse } from 'axios'

const PRODUCTION_LINE_API_PREFIX = `${API_PREFIX}/production-lines`

export type ProductionLinesPaginationResponse = {
    data: ProductionLineModel[]
    meta: {
        current_page: number
        last_page: number
        per_page: number
        total: number
        from: number | null
        to: number | null
    }
}

export type ProductionLineFilters = {
    organization_id?: number
}

const productionLinesApi = {
    getProductionLines: (
        params?: Partial<PaginationType & ProductionLineFilters>
    ): Promise<ProductionLinesPaginationResponse> =>
        api.get(`${PRODUCTION_LINE_API_PREFIX}${buildQueryUrl(params)}`).then(res => res.data),

    getProductionLine: (id: number): Promise<AxiosResponse<ProductionLineModel>> =>
        api.get(`${PRODUCTION_LINE_API_PREFIX}/${id}`).then(res => res.data),

    createProductionLine: (
        data: ProductionLineCreateModel
    ): Promise<AxiosResponse<ProductionLineModel>> => api.post(PRODUCTION_LINE_API_PREFIX, data),

    updateProductionLine: (
        id: number,
        data: ProductionLineModel
    ): Promise<AxiosResponse<ProductionLineModel>> =>
        api.patch(`${PRODUCTION_LINE_API_PREFIX}/${id}`, data),

    deleteProductionLine: (id: number): Promise<AxiosResponse<{ message: string }>> =>
        api.delete(`${PRODUCTION_LINE_API_PREFIX}/${id}`)
}

export default productionLinesApi
